import {
  IRecommendationNewbuildingInfrastructure,
  TRegularInfrastructureItem,
  TRegularInfrastructureType,
} from '../../../types/map';
import { trackInfrastructureItemClick } from './trackInfrastructureItemClick';
import { trackSimilarNewbuildingInfrastructureClick } from './trackSimilarNewbuildingInfrastructureClick';

export interface ITrackInfrastructureClickParams {
  objectType?: string;
  infrastructureItems: TRegularInfrastructureItem[];
}

export function trackInfrastructureClick({ objectType, infrastructureItems }: ITrackInfrastructureClickParams) {
  if ((objectType as TRegularInfrastructureType) === 'similar_newbuilding') {
    const newbuildings = infrastructureItems.filter(
      (item: TRegularInfrastructureItem): item is IRecommendationNewbuildingInfrastructure => {
        return item.type === objectType;
      },
    );

    trackSimilarNewbuildingInfrastructureClick(newbuildings);

    return;
  }

  trackInfrastructureItemClick(objectType);
}
